import api from "./api";

// -------------------- WORKERS --------------------
export const fetchWorkers = async () => {
  const res = await api.get("/core/workers/");
  return res.data;
};

export const createWorker = async (worker) => {
  const res = await api.post("/core/workers/", worker);
  return res.data;
};

export const updateWorker = async (id, worker) => {
  const res = await api.put(`/core/workers/${id}/`, worker);
  return res.data;
};

export const deleteWorker = async (id) => {
  const res = await api.delete(`/core/workers/${id}/`);
  return res.data;
};
